import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Luodaan uusi tarjous',
  subtitle: 'Miten asiakas saa ilmaisen tuotteen?',
  validation: {
    required: 'Valitse tarjoustyyppi',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Tilauksen kokonaisarvo',
      description: 'Esim. 10 % alennus tilauksesta, kun käytät 20 {{currency}}',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Valitut tuotteet',
      description: 'Esim. 10 % alennus 12 tuuman pizzoista.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Valitut tuotteet',
      description: 'Esim. 1 {{currency}} alennus 12 tuuman pizzoista.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Tilauksen kokonaisarvo',
      description: 'Esim. 1 {{currency}} alennus tilauksesta, kun käytät 20 {{currency}}',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Osta 1, saat 1 ilmaiseksi',
      description: 'Esim. Osta 1 pizza, saat toisen ilmaiseksi. Halvempi pizza alennetaan.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Osta 1, saat toisen puoleen hintaan',
      description: 'Esim. Osta 1 pizza, saat toisen puoleen hintaan. Halvempi pizza alennetaan.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Ostamalla toisen tuotteen',
      description: 'Esim. Saat ilmaisen juoman tilatessasi aterian.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Käyttämällä kiinteän summan {{currency}}',
      description: 'Esim. Saat ilmaisen jälkiruoan, kun käytät 20 {{currency}}.',
    },
  },
};
